import { PureComponent } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { Button } from '~/elements';
import { setHeadlineBackButtonConfig } from '~/ocab-services/services.actions';
import { journeyStateSelectors } from '~/api';

export class BeautyToBeautySocietyPartnersNotFound extends PureComponent {
  componentDidMount() {
    const { dispatchSetHeadlineBackButtonConfig } = this.props;

    dispatchSetHeadlineBackButtonConfig({
      isDisplayed: true,
      title: 'Select treatment',
      goBack: this.handleOnClick,
    });
  }

  handleOnClick = (event) => {
    event.preventDefault();

    const { prevPath } = this.props;

    window.location.href = prevPath;
  };

  render() {
    return (
      <Button view="primary" inline onClick={this.handleOnClick}>
        Go back to treatments
      </Button>
    );
  }
}

export const mapStateToProps = (state) => ({
  prevPath: journeyStateSelectors.selectPathConfigForPage(state).prevPath,
});
const mapDispatchToProps = {
  dispatchSetHeadlineBackButtonConfig: setHeadlineBackButtonConfig,
};

export const ConnectedBeautyToBeautySocietyPartnersNotFound = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BeautyToBeautySocietyPartnersNotFound);

BeautyToBeautySocietyPartnersNotFound.propTypes = {
  prevPath: PropTypes.string,

  dispatchSetHeadlineBackButtonConfig: PropTypes.func.isRequired,
};

BeautyToBeautySocietyPartnersNotFound.defaultProps = {
  prevPath: '',
};
